var React = require('react');

function LightningInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M9.05,27.76a1.26,1.26,0,0,1-.62-.17,1.24,1.24,0,0,1-.57-1.48l2.9-8.7H6.46a1.24,1.24,0,0,1-1.12-.7,1.26,1.26,0,0,1,.13-1.32L16.68,1A1.26,1.26,0,0,1,18.22.66a1.25,1.25,0,0,1,.66,1.43L16.69,10.6h5a1.25,1.25,0,0,1,.95,2.07L10,27.32A1.22,1.22,0,0,1,9.05,27.76ZM9,14.91h3.47a1.25,1.25,0,0,1,1.19,1.65L12.23,20.9,19,13.1H15.08a1.24,1.24,0,0,1-1.21-1.56L15,7.28Z"})));
}

LightningInline.defaultProps = {"viewBox":"0 0 28.29 28.29"};

module.exports = LightningInline;

LightningInline.default = LightningInline;
